/**
 * @module app.kya.list.signContractCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SignContractCtrl($scope, $uibModalInstance) {
        var self = {};

        // Sign modal

        self.dateSignature = moment().format('DD/MM/YYYY');

        self.sign = function() {
            $uibModalInstance.close({
                dateSignature: self.dateSignature
            });
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    SignContractCtrl.$inject = ['$scope', '$uibModalInstance'];

    angular.module('app.kya.list.signContractCtrl', ['ui.bootstrap']).controller('SignContractCtrl', SignContractCtrl);
});
